import { mapGetters } from 'vuex';
import { Loading } from 'element-ui';
import { report } from '@/api/report';
import { mixins } from '@/mixins';
import { getShopTicket } from '@/api/login';
import Navigation from '@/components/Navigation/Navigation.vue';
import OpenApp from '@/components/OpenApp/OpenApp.vue';
import TaskItem from '@/components/TaskItem/TaskItem.vue';

export default {
	name: 'Task',

	mixins: [mixins],

	data() {
		return {
			taskList: [],
		};
	},

	computed: {
    ...mapGetters(['userName', 'photo', 'isLogin', 'points', 'userId', 'hasCheckIn', 'inviteCode', 'userToken']),
  },

	methods: {
		clickTask(opts) {
			const inviteCode = this.inviteCode || '';

			if (opts.id === 'checkin') {
				this.$router.push({
          path: `/checkin`,
          query: {
            invite_code: inviteCode,
          }
        });
        report({
		      event_type: 'click',
		      event_value: 'task_checkin'
		    });
			}

			if (opts.id === 'download') {
				this.$router.push({
          path: `/download`,
          query: {
            invite_code: inviteCode,
          }
        });
        report({
		      event_type: 'click',
		      event_value: 'task_download'
		    });
			}

			if (opts.id === 'reply') {
				this.$router.push({
          path: `/download`,
          query: {
            invite_code: inviteCode,
          }
        });
        report({
		      event_type: 'click',
		      event_value: 'task_reply'
		    });
			}

			if (opts.id === 'first_recharge') {
				this.recharge();
        report({
		      event_type: 'click',
		      event_value: 'task_recharge'
		    });
			}
		},

		async recharge() {
			const inviteCode = this.inviteCode || '';
			const loading = Loading.service({
	      fullscreen: true,
	      customClass: 'text-loading',
	      text: 'Shop connecting...'
	    });

			try {
				const userToken = this.userToken || '';
				const res = await getShopTicket({
					token: userToken,
				});
				const ticketEncode = encodeURIComponent(res.data.ticket);
				const redirectURL = encodeURIComponent(`https://mobile.akaliai.com/web/user_center?invite_code=${inviteCode}`);

				window.location.href = `https://cozytaps.com/desktop/shop?ticket=${ticketEncode}&open_type=shop&redirect_url=${redirectURL}`;
				setTimeout(() => {
					loading.close();
				}, 3000);
			}
			catch(err) {
				console.log(err);
				loading.close();
			}
		},
	},

	activated() {
		report({
      event_type: 'view',
      event_value: 'task'
    });
	},

	mounted() {
		this.taskList = [
			{
				id: 'checkin',
				name: 'Checkin',
				description: `Log in every day to get gems.`
			},

			{
				id: 'first_recharge',
				name: 'First Recharge(+110)',
				description: 'Recharge for the first time. You can get an additional 110 gems rewards.'
			},

			{
				id: 'download',
				name: 'Download App(+20)',
				description: `Download ${this.appName} App and log into the app for the first time. You can get 20 gems rewards.`
			},

			{
				id: 'reply',
				name: 'Message Reply(+50)',
				description: `In ${this.appName} App. Long press on any bot message. and reply to this message. You can get 50 gems rewards. <br>Function introduction: Flexible switching of dialogue contexts. Agile adjustment of story progression. Enhanced dialogue error correction. if unsatisfied with a character’s response. simply reply to a past message for timely corrections. Efficient context management to help optimize your time investment.`
			}
		];
	},

	components: {
		Navigation,
		OpenApp,
		TaskItem
	}
};
